import {
  data
} from '../data/mockData.js';
export const layoutConfig = {};
export const layoutConfig1 = {
  "pageTitle": "发起项目付款申请",
  "introduction": [],
  "contents": [{
      "field": "basicInfo",
      "type": "commonForm",
      "contents": [{
          "label": "申请人",
          "field": "applier_id",
          "type": "text",
          "show": true
        },
        {
          "label": "付款公司",
          "field": "company_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/company-options"
          },
          "required": true
        },
        {
          "label": "项目号",
          "field": "project_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/project-payment/projects"
          },
          "required": true
        },
        {
          "label": "收款方",
          "field": "payee_name",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "required": true
        },
        {
          "label": "开户银行",
          "field": "open_account_bank",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写银行名称，如：中国建设银行",
          "required": true
        },
        {
          "label": "开户银行支行",
          "field": "open_account_bank_branch",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写到XX支行，如：北京中关村支行",
          "required": true
        },
        {
          "label": "开户地",
          "field": "open_account_place",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写到XX省XX市，如：河北省唐山市",
          "required": true
        },
        {
          "label": "银行账号",
          "field": "bank_account",
          "type": "input",
          "show": true,
          "maxLength": 30,
          "number": true,
          "required": true
        },
        {
          "label": "需要银行回单",
          "field": "is_need_receipt",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/bool-radio-options"
          },
          "required": true
        },
        {
          "label": "发票",
          "field": "provide_invoices",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/provide-invoices-option"
          },
          "required": true
        }
      ]
    },
    {
      "field": "detailInfo",
      "type": "multiForm",
      "formTitle": "付款明细",
      "functions": [{
        "title": "录入回票结果",
        "action": "invoice_result",
        "depends": {
          "status": 0
        }
      }],
      "contents": [{
          "label": "付款类别",
          "field": "type",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/pay-type-options"
          },
          "required": true,
          "trigger": [{
              "target": "budget_subject_id",
              "requirements": [{
                "name": "include",
                "params": {
                  "value": [
                    "税金及附加-城建税",
                    30,
                    "税金及附加-教育费附加",
                    31,
                    "税金及附加-地方教育附加",
                    32,
                    "税金及附加-印花税",
                    33,
                    "税金及附加-防洪费",
                    34,
                    "税金及附加-垃圾清运费",
                    35,
                    "增值税",
                    36,
                    "企业所得税",
                    37,
                    "税金及附加-水利建设专项资金",
                    38,
                    "税金及附加-土地使用税",
                    39,
                    "股权收购款",
                    48,
                    "借款",
                    49,
                    "还借款",
                    50,
                    "注资款",
                    51,
                    "利息支出",
                    53,
                    "退款",
                    55,
                    "押金",
                    56
                  ]
                }
              }],
              "actions": [{
                "name": "hidden"
              }]
            },
            {
              "target": "budget_subject_id",
              "requirements": [{
                "name": "notInclude",
                "params": {
                  "value": [
                    "税金及附加-城建税",
                    30,
                    "税金及附加-教育费附加",
                    31,
                    "税金及附加-地方教育附加",
                    32,
                    "税金及附加-印花税",
                    33,
                    "税金及附加-防洪费",
                    34,
                    "税金及附加-垃圾清运费",
                    35,
                    "增值税",
                    36,
                    "企业所得税",
                    37,
                    "税金及附加-水利建设专项资金",
                    38,
                    "税金及附加-土地使用税",
                    39,
                    "股权收购款",
                    48,
                    "借款",
                    49,
                    "还借款",
                    50,
                    "注资款",
                    51,
                    "利息支出",
                    53,
                    "退款",
                    55,
                    "押金",
                    56
                  ]
                }
              }],
              "actions": [{
                "name": "show"
              }]
            }
          ]
        },
        {
          "label": "业务目的",
          "field": "business_purpose",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "required": true
        },
        {
          "label": "备注",
          "field": "remarks",
          "type": "textArea",
          "show": true,
          "maxLength": 100
        },
        {
          "label": "付款金额(元)",
          "field": "money",
          "type": "number",
          "show": true,
          "maxValue": 99999999,
          "required": true
        },
        {
          "label": "预算科目",
          "field": "budget_subject_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/subject-options"
          },
          "required": true
        },
        {
          "label": "发票日期",
          "field": "invoice_date",
          "type": "datePicker",
          "show": true,
          "required": true
        },
        {
          "label": "发票类型",
          "field": "invoice_type",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/invoice-type-option"
          },
          "required": true,
          "trigger": [{
              "target": "tax_rate",
              "requirements": [{
                "name": "include",
                "params": {
                  "value": [
                    1,
                    "增值税专用发票"
                  ]
                }
              }],
              "actions": [{
                "name": "show"
              }]
            },
            {
              "target": "tax_rate",
              "requirements": [{
                "name": "include",
                "params": {
                  "value": [
                    2,
                    "增值税普通发票"
                  ]
                }
              }],
              "actions": [{
                "name": "hidden"
              }]
            }
          ]
        },
        {
          "label": "税率",
          "field": "tax_rate",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/tax-rate-option"
          },
          "required": true
        },
        {
          "label": "发票附件",
          "field": "attachment",
          "type": "upload",
          "show": true
        }
      ]
    },
    {
      "field": "summationInfo",
      "type": "summation",
      "contents": [{
        "label": "总付款金额(元)",
        "field": "total_pay",
        "create-type": "text",
        "create-show": true,
        "dependsParams": "money",
        "detail-type": "text",
        "detail-show": true,
        "dependsParams": "money"
      }]
    },
    {
      "label": "附件",
      "type": "upload",
      "field": "attachment",
      "options": []
    }
  ]
};
export const layoutConfig2 = {
  "pageTitle": "发起项目付款申请",
  "introduction": [],
  "contents": [{
      "field": "basicInfo",
      "type": "commonForm",
      "contents": [{
          "label": "申请人",
          "field": "applier_id",
          "type": "text",
          "show": true
        },
        {
          "label": "付款公司",
          "field": "company_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/company-options"
          },
          "required": true
        },
        {
          "label": "项目号",
          "field": "project_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/project-payment/projects"
          },
          "required": true
        },
        {
          "label": "收款方",
          "field": "payee_name",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "required": true
        },
        {
          "label": "开户银行",
          "field": "open_account_bank",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写银行名称，如：中国建设银行",
          "required": true
        },
        {
          "label": "开户银行支行",
          "field": "open_account_bank_branch",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写到XX支行，如：北京中关村支行",
          "required": true
        },
        {
          "label": "开户地",
          "field": "open_account_place",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写到XX省XX市，如：河北省唐山市",
          "required": true
        },
        {
          "label": "银行账号",
          "field": "bank_account",
          "type": "input",
          "show": true,
          "maxLength": 30,
          "number": true,
          "required": true
        },
        {
          "label": "需要银行回单",
          "field": "is_need_receipt",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/bool-radio-options"
          },
          "required": true
        },
        {
          "label": "发票",
          "field": "provide_invoices",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/provide-invoices-option"
          },
          "required": true
        }
      ]
    },
    {
      "field": "detailInfo",
      "type": "multiForm",
      "formTitle": "付款明细",
      "functions": [{
        "title": "录入回票结果",
        "action": "invoice_result",
        "depends": {
          "status": 0
        }
      }],
      "contents": [{
          "label": "付款类别",
          "field": "type",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/pay-type-options"
          },
          "required": true,
          "trigger": [{
              "target": "budget_subject_id",
              "requirements": [{
                "name": "include",
                "params": {
                  "value": [
                    "税金及附加-城建税",
                    30,
                    "税金及附加-教育费附加",
                    31,
                    "税金及附加-地方教育附加",
                    32,
                    "税金及附加-印花税",
                    33,
                    "税金及附加-防洪费",
                    34,
                    "税金及附加-垃圾清运费",
                    35,
                    "增值税",
                    36,
                    "企业所得税",
                    37,
                    "税金及附加-水利建设专项资金",
                    38,
                    "税金及附加-土地使用税",
                    39,
                    "股权收购款",
                    48,
                    "借款",
                    49,
                    "还借款",
                    50,
                    "注资款",
                    51,
                    "利息支出",
                    53,
                    "退款",
                    55,
                    "押金",
                    56
                  ]
                }
              }],
              "actions": [{
                "name": "hidden"
              }]
            },
            {
              "target": "budget_subject_id",
              "requirements": [{
                "name": "notInclude",
                "params": {
                  "value": [
                    "税金及附加-城建税",
                    30,
                    "税金及附加-教育费附加",
                    31,
                    "税金及附加-地方教育附加",
                    32,
                    "税金及附加-印花税",
                    33,
                    "税金及附加-防洪费",
                    34,
                    "税金及附加-垃圾清运费",
                    35,
                    "增值税",
                    36,
                    "企业所得税",
                    37,
                    "税金及附加-水利建设专项资金",
                    38,
                    "税金及附加-土地使用税",
                    39,
                    "股权收购款",
                    48,
                    "借款",
                    49,
                    "还借款",
                    50,
                    "注资款",
                    51,
                    "利息支出",
                    53,
                    "退款",
                    55,
                    "押金",
                    56
                  ]
                }
              }],
              "actions": [{
                "name": "show"
              }]
            }
          ]
        },
        {
          "label": "业务目的",
          "field": "business_purpose",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "required": true
        },
        {
          "label": "备注",
          "field": "remarks",
          "type": "textArea",
          "show": true,
          "maxLength": 100
        },
        {
          "label": "付款金额(元)",
          "field": "money",
          "type": "number",
          "show": true,
          "maxValue": 99999999,
          "required": true
        },
        {
          "label": "预算科目",
          "field": "budget_subject_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/subject-options"
          },
          "required": true
        },
        {
          "label": "预计回票日期",
          "field": "invoice_date",
          "type": "datePicker",
          "show": true,
          "required": true
        },
        // {
        //   "label": "发票类型",
        //   "field": "invoice_type",
        //   "type": "radio",
        //   "show": true,
        //   "fetch": {
        //     "url": "api/fas/payment/invoice-type-option"
        //   },
        //   "required": true,
        //   "trigger": [{
        //       "target": "tax_rate",
        //       "requirements": [{
        //         "name": "include",
        //         "params": {
        //           "value": [
        //             1,
        //             "增值税专用发票"
        //           ]
        //         }
        //       }],
        //       "actions": [{
        //         "name": "show"
        //       }]
        //     },
        //     {
        //       "target": "tax_rate",
        //       "requirements": [{
        //         "name": "include",
        //         "params": {
        //           "value": [
        //             2,
        //             "增值税普通发票"
        //           ]
        //         }
        //       }],
        //       "actions": [{
        //         "name": "hidden"
        //       }]
        //     }
        //   ]
        // },
        // {
        //   "label": "税率",
        //   "field": "tax_rate",
        //   "type": "radio",
        //   "show": true,
        //   "fetch": {
        //     "url": "api/fas/payment/tax-rate-option"
        //   },
        //   "required": true
        // },
        {
          "label": "发票附件",
          "field": "attachment",
          "type": "upload",
          "show": true,
        }
      ]
    },
    {
      "field": "summationInfo",
      "type": "summation",
      "contents": [{
        "label": "总付款金额(元)",
        "field": "total_pay",
        "create-type": "text",
        "create-show": true,
        "dependsParams": "money",
        "detail-type": "text",
        "detail-show": true,
        "dependsParams": "money"
      }]
    },
    {
      "label": "附件",
      "type": "upload",
      "field": "attachment",
      "options": []
    }
  ]
}
export const layoutConfig3 = {
  "pageTitle": "发起项目付款申请",
  "introduction": [],
  "contents": [{
      "field": "basicInfo",
      "type": "commonForm",
      "contents": [{
          "label": "申请人",
          "field": "applier_id",
          "type": "text",
          "show": true
        },
        {
          "label": "付款公司",
          "field": "company_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/company-options"
          },
          "required": true
        },
        {
          "label": "项目号",
          "field": "project_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/project-payment/projects"
          },
          "required": true
        },
        {
          "label": "收款方",
          "field": "payee_name",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "required": true
        },
        {
          "label": "开户银行",
          "field": "open_account_bank",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写银行名称，如：中国建设银行",
          "required": true
        },
        {
          "label": "开户银行支行",
          "field": "open_account_bank_branch",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写到XX支行，如：北京中关村支行",
          "required": true
        },
        {
          "label": "开户地",
          "field": "open_account_place",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "placeholder": "填写到XX省XX市，如：河北省唐山市",
          "required": true
        },
        {
          "label": "银行账号",
          "field": "bank_account",
          "type": "input",
          "show": true,
          "maxLength": 30,
          "number": true,
          "required": true
        },
        {
          "label": "需要银行回单",
          "field": "is_need_receipt",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/bool-radio-options"
          },
          "required": true
        },
        {
          "label": "发票",
          "field": "provide_invoices",
          "type": "radio",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/provide-invoices-option"
          },
          "required": true
        }
      ]
    },
    {
      "field": "detailInfo",
      "type": "multiForm",
      "formTitle": "付款明细",
      "functions": [{
        "title": "录入回票结果",
        "action": "invoice_result",
        "depends": {
          "status": 0
        }
      }],
      "contents": [{
          "label": "付款类别",
          "field": "type",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/pay-type-options"
          },
          "required": true,
          "trigger": [{
              "target": "budget_subject_id",
              "requirements": [{
                "name": "include",
                "params": {
                  "value": [
                    "税金及附加-城建税",
                    30,
                    "税金及附加-教育费附加",
                    31,
                    "税金及附加-地方教育附加",
                    32,
                    "税金及附加-印花税",
                    33,
                    "税金及附加-防洪费",
                    34,
                    "税金及附加-垃圾清运费",
                    35,
                    "增值税",
                    36,
                    "企业所得税",
                    37,
                    "税金及附加-水利建设专项资金",
                    38,
                    "税金及附加-土地使用税",
                    39,
                    "股权收购款",
                    48,
                    "借款",
                    49,
                    "还借款",
                    50,
                    "注资款",
                    51,
                    "利息支出",
                    53,
                    "退款",
                    55,
                    "押金",
                    56
                  ]
                }
              }],
              "actions": [{
                "name": "hidden"
              }]
            },
            {
              "target": "budget_subject_id",
              "requirements": [{
                "name": "notInclude",
                "params": {
                  "value": [
                    "税金及附加-城建税",
                    30,
                    "税金及附加-教育费附加",
                    31,
                    "税金及附加-地方教育附加",
                    32,
                    "税金及附加-印花税",
                    33,
                    "税金及附加-防洪费",
                    34,
                    "税金及附加-垃圾清运费",
                    35,
                    "增值税",
                    36,
                    "企业所得税",
                    37,
                    "税金及附加-水利建设专项资金",
                    38,
                    "税金及附加-土地使用税",
                    39,
                    "股权收购款",
                    48,
                    "借款",
                    49,
                    "还借款",
                    50,
                    "注资款",
                    51,
                    "利息支出",
                    53,
                    "退款",
                    55,
                    "押金",
                    56
                  ]
                }
              }],
              "actions": [{
                "name": "show"
              }]
            }
          ]
        },
        {
          "label": "业务目的",
          "field": "business_purpose",
          "type": "input",
          "show": true,
          "maxLength": 100,
          "required": true
        },
        {
          "label": "备注",
          "field": "remarks",
          "type": "textArea",
          "show": true,
          "maxLength": 100
        },
        {
          "label": "付款金额(元)",
          "field": "money",
          "type": "number",
          "show": true,
          "maxValue": 99999999,
          "required": true
        },
        {
          "label": "预算科目",
          "field": "budget_subject_id",
          "type": "select",
          "show": true,
          "fetch": {
            "url": "api/fas/payment/subject-options"
          },
          "required": true
        },
        {
          "label": "费用发生日期",
          "field": "invoice_date",
          "type": "datePicker",
          "show": true,
          "required": true
        },
        {
          "label": "发票附件",
          "field": "attachment",
          "type": "upload",
          "show": true
        }
      ]
    },
    {
      "field": "summationInfo",
      "type": "summation",
      "contents": [{
        "label": "总付款金额(元)",
        "field": "total_pay",
        "create-type": "text",
        "create-show": true,
        "dependsParams": "money",
        "detail-type": "text",
        "detail-show": true,
        "dependsParams": "money"
      }]
    },
    {
      "label": "附件",
      "type": "upload",
      "field": "attachment",
      "options": []
    }
  ]
}
export const layoutConfigDetail = {
  "pageTitle": "预算调整详情",
  "functions": [{
    title: "撤回",
    action: "withdraw"
  }, {
    title: "修改",
    action: "modify_form"
  }, {
    title: "复制",
    action: "copy"
  }],
  "contents": [{
      "field": "basicInfo",
      "type": "commonForm",
      "contents": [{
        "label": "采购类型",
        "field": "provide_invoices",
        "type": "radio",
        "show": true,
        "fetch": {
          // "url": "api\/fas\/payment\/provide-invoices-option"
        },
        "options": [{
            id: 1,
            name: '物品'
          },
          {
            id: 2,
            name: '服务'
          },
        ],
        "required": true,
      }, {
        "label": "采购内容",
        "field": "neirong",
        "type": "input",
        "show": true,
        "maxLength": 100,
        "required": true
      }, {
        "label": "说明",
        "field": "shuoming",
        "type": "input",
        "show": true,
        "maxLength": 100,
      }, {
        "label": "采购用途",
        "field": "yongtu",
        "type": "input",
        "show": true,
        "maxLength": 100,
        "required": true
      }, {
        "label": "单价",
        "field": "danjia",
        "type": "number",
        "show": true,
        "required": true,
        trigger: [{
          target: "money", // money对应金额字段
          requirements: [{
            name: "exist"
          }],
          actions: [{
            name: "multiply",
            params: []
          }],
          depends: [{
            number: { //number为数量字段
              from: "same"
            }
          }]
        }]
      }, {
        "label": "数量",
        "field": "number",
        "type": "number",
        "show": true,
        "required": true,
        trigger: [{
          target: "money",
          requirements: [{
            name: "exist"
          }],
          actions: [{
            name: "multiply",
            params: []
          }],
          depends: [{
            danjia: { //danjia为单价字段
              from: "same"
            }
          }]
        }]
      }, {
        "label": "金额",
        "field": "money",
        "type": "text",
        "show": true,
      }, {
        "label": "预算科目",
        "field": "subject",
        "type": "select",
        "show": true,
        "fetch": {
          // "url": "api\/fas\/payment\/subject-options"
        },
        "required": true
      }, {
        "label": "备注",
        "field": "remarks",
        "type": "textArea",
        "show": true,
        "maxLength": 100
      }, ]
    },
    {
      "field": "summationInfo",
      "type": "summation",
      "contents": [{
        "label": "总付款金额(元)",
        "field": "total_pay",
        "type": "text",
        "show": true,
        "dependsParams": "money"
      }]
    },
    {
      "label": "附件",
      "type": "upload",
      "field": "appli_annex",
      "options": []
    }
  ]
};

export const mockParams = {
  basicInfo: {
    applicant_info: "李阳 000027 技术研发部,用户产品研发团队"
  },
  budgetInfo: data,
  appli_annex: [],
}

export const mockParamsDetail = {
  basicInfo: {
    applicant_info: "李阳 000027 技术研发部,用户产品研发团队",
    team: '技术部',
    remarks: '测试一下行不行'
  },
  budgetInfo: data,
  appli_annex: [],
  status: '审批中',
  process_status: true
}